import { Col, Typography } from 'antd'
import _ from 'lodash'
import { Popover } from '@vzmi/shp_shared_compo'
import { EMPTY_VALUE } from '../../../../../../../constants/globalTypes'
import { checkIsFakeProductId, getAttrMap } from '../../../helpers'
import styles from './index.css'

const { Paragraph } = Typography

const CustomProductIdCol = props => {
  const {
    currentModelField,
    itemSpecHeader,
    products
  } = props
  // models[2] > 2
  const rowIndex = _.trim(currentModelField, 'models[]')
  const isTwoLayerListing = !_.isEmpty(itemSpecHeader)
  const attrMap = getAttrMap(isTwoLayerListing)
  // 單雙層屬性賣場的商品編號、名稱實際存在不同欄位
  const {
    [attrMap.productId]: productId,
    [attrMap.productName]: productName
  } = _.get(products, rowIndex, {})
  const isFakeId = checkIsFakeProductId(productId)
  return (
    <Col
      span={3}
      className={styles.customCol}
    >
      <p>{isFakeId ? EMPTY_VALUE : productId}</p>
      <br />
      <Popover content={productName}>
        <Paragraph
          ellipsis={{ rows: 2 }}
        >
          {productName}
        </Paragraph>
      </Popover>
    </Col>
  )
}

export default CustomProductIdCol
